<div class="confirmSimulationLaunchPopup">
    <h2 class="confirmSimulationLaunchPopup-title"[i18nKey]="'simulation.page.launch.simulation.in.progress'"></h2>
    <div class="confirmSimulationLaunchPopup-title"[i18nKey]="'simulation.page.launch.simulation.in.progress.info'"></div>

    <div class="confirmSimulationLaunchPopup-img"></div>

    <div class="confirmSimulationLaunchPopup-period">{{ displayedPeriod }}</div>

    <span class="confirmSimulationLaunchPopup-currentStep">
        {{ 'simulation.page.launch.simulation.step.' + currentStep | translate }}
    </span>

    <ng-container *ngIf="currentStep < 4">
        <span *ngFor="let step of subSteps"
              [class._current]="currentSubStep == step"
              [class._validate]="currentSubStep > step"
              class="confirmSimulationLaunchPopup-substeps-item">
            <i class="fas fa-check _check"></i>
            <i class="fas fa-spinner fa-spin _load"></i>
            {{ 'simulation.page.launch.simulation.area.simulation.substep.' + step | translate }}
        </span>
    </ng-container>
</div>
